// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"289":"721cb7f4","453":"258b012d","732":"396e22c6"}[chunkId] + ".chunk.js";
};